// Crate statues Enums
export const statuses = {
    CANCELED: 2,
    MISSED:   4,
    APPROVED: 3,
};

export const payment_methods = {
    CASH: 0,
    CREDIT_CARD:   1,
    INSTALLMENT: 2,
};